<template>
  <div class="descriptions-container">
    <!-- 显示 -->
    <el-descriptions
      v-if="status == 1"
      size="small"
      :column="column"
      border
      :label-style="labelStyle"
    >
      <el-descriptions-item
        contentStyle="width: 180px"
        v-for="(item, index) in sysEntityDtoList"
        :key="index"
      >
        <template slot="label">{{ item.fieldName }}</template>
        <div v-if="item.fieldType == 1">
          {{
            customSelectDataShow(
              sysEntityExtDto[
                item.fieldTag.substring(
                  item.fieldTag.indexOf("-") + 1,
                  item.fieldTag.length
                )
              ],
              JSON.parse(item.fieldTypeRelinfo)
            )
          }}
        </div>
        <!-- excel -->
        <div v-else-if="item.fieldType == 2">
          <el-button
            v-if="
              sysEntityExtDto[
                item.fieldTag.substring(
                  item.fieldTag.indexOf('-') + 1,
                  item.fieldTag.length
                )
              ] != null &&
              sysEntityExtDto[
                item.fieldTag.substring(
                  item.fieldTag.indexOf('-') + 1,
                  item.fieldTag.length
                )
              ] != undefined &&
              sysEntityExtDto[
                item.fieldTag.substring(
                  item.fieldTag.indexOf('-') + 1,
                  item.fieldTag.length
                )
              ] != ''
            "
            @click="
              mainExcelOpen(
                sysEntityExtDto[
                  item.fieldTag.substring(
                    item.fieldTag.indexOf('-') + 1,
                    item.fieldTag.length
                  )
                ]
              )
            "
            size="mini"
            type="primary"
            >打开</el-button
          >
          <el-button
            v-else
            size="mini"
            type="primary"
            @click="
              mainExcelSuccess(
                sysEntityExtDto,
                item.fieldTag.substring(
                  item.fieldTag.indexOf('-') + 1,
                  item.fieldTag.length
                ),
                item,
                66
              )
            "
            >打开</el-button
          >
        </div>
        <!-- 文件 -->
        <div v-else-if="item.fieldType == 5">
          <el-button
            size="mini"
            type="primary"
            @click="
              updateFileList(
                sysEntityExtDto[
                  item.fieldTag.substring(
                    item.fieldTag.indexOf('-') + 1,
                    item.fieldTag.length
                  )
                ],
                item
              )
            "
          >
            {{
              getFileList(
                sysEntityExtDto[
                  item.fieldTag.substring(
                    item.fieldTag.indexOf("-") + 1,
                    item.fieldTag.length
                  )
                ]
              )
            }}
          </el-button>
        </div>
        <div v-else>
          {{
            sysEntityExtDto[
              item.fieldTag.substring(
                item.fieldTag.indexOf("-") + 1,
                item.fieldTag.length
              )
            ]
          }}
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <!-- 编辑 -->
    <el-descriptions
      v-if="status == 0"
      size="small"
      :column="column"
      border
      :label-style="labelStyle"
    >
      <el-descriptions-item
        contentStyle="width: 220px"
        v-for="(item, index) in sysEntityDtoList"
        :key="index"
      >
        <template slot="label">{{ item.fieldName }}</template>
        <el-input
          v-if="item.fieldType == 0"
          :placeholder="item.fieldName"
          style="width: 100%"
          v-model="
            sysEntityExtDto[
              item.fieldTag.substring(
                item.fieldTag.indexOf('-') + 1,
                item.fieldTag.length
              )
            ]
          "
        />
        <el-select
          v-if="item.fieldType == 1"
          style="width: 100%"
          v-model="
            sysEntityExtDto[
              item.fieldTag.substring(
                item.fieldTag.indexOf('-') + 1,
                item.fieldTag.length
              )
            ]
          "
          placeholder="请选择"
        >
          <el-option
            v-for="item in JSON.parse(item.fieldTypeRelinfo)"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          v-if="item.fieldType == 3"
          clearable
          value-format="yyyy-MM-dd"
          type="date"
          style="width: 100%"
          :placeholder="item.fieldName"
          v-model="
            sysEntityExtDto[
              item.fieldTag.substring(
                item.fieldTag.indexOf('-') + 1,
                item.fieldTag.length
              )
            ]
          "
        />
        <el-date-picker
          v-if="item.fieldType == 4"
          clearable
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          style="width: 100%"
          :placeholder="item.fieldName"
          v-model="
            sysEntityExtDto[
              item.fieldTag.substring(
                item.fieldTag.indexOf('-') + 1,
                item.fieldTag.length
              )
            ]
          "
        />
        <!-- excel -->
        <div v-if="item.fieldType == 2">
          <el-button
            v-if="
              sysEntityExtDto[
                item.fieldTag.substring(
                  item.fieldTag.indexOf('-') + 1,
                  item.fieldTag.length
                )
              ] != null &&
              sysEntityExtDto[
                item.fieldTag.substring(
                  item.fieldTag.indexOf('-') + 1,
                  item.fieldTag.length
                )
              ] != undefined &&
              sysEntityExtDto[
                item.fieldTag.substring(
                  item.fieldTag.indexOf('-') + 1,
                  item.fieldTag.length
                )
              ] != ''
            "
            @click="
              mainExcelOpen(
                sysEntityExtDto[
                  item.fieldTag.substring(
                    item.fieldTag.indexOf('-') + 1,
                    item.fieldTag.length
                  )
                ]
              )
            "
            size="mini"
            type="primary"
            >打开</el-button
          >
          <el-button
            v-else
            size="mini"
            type="primary"
            @click="
              mainExcelSuccess(
                sysEntityExtDto,
                item.fieldTag.substring(
                  item.fieldTag.indexOf('-') + 1,
                  item.fieldTag.length
                ),
                item,
                66
              )
            "
            >打开</el-button
          >
        </div>
        <!-- 文件 -->
        <div v-if="item.fieldType == 5">
          <el-button
            size="mini"
            type="primary"
            @click="
              updateFileList(
                sysEntityExtDto[
                  item.fieldTag.substring(
                    item.fieldTag.indexOf('-') + 1,
                    item.fieldTag.length
                  )
                ],
                item,
                66
              )
            "
          >
            {{
              getFileList(
                sysEntityExtDto[
                  item.fieldTag.substring(
                    item.fieldTag.indexOf("-") + 1,
                    item.fieldTag.length
                  )
                ]
              )
            }}
          </el-button>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <!-- 上传文件 -->
    <el-dialog
      :visible.sync="dialogState.show1"
      :close-on-click-modal="false"
      append-to-body
      class="dialog"
      :title="dialogTitle"
      width="50%"
      @close="dialogClose"
    >
      <myUploadTable
        :list="tableList"
        :type="dialogType"
        :markIndex="markIndex"
        :status="status"
        @uploadSuccess="uploadSuccess"
        @uploadDelete="uploadDelete"
      >
      </myUploadTable>
    </el-dialog>
  </div>
</template>
<script>
import { fileInfo_getFileId } from "@/api/myController/system";
export default {
  props: {
    // 0.编辑，1.查看
    status: {
      type: Number,
      default: 0,
    },
    // 有几列
    column: {
      type: Number,
      default: 4,
    },
    // 自定义字段
    sysEntityDtoList: {
      type: Array,
      default() {
        return [];
      },
    },
    // 自定义字段返回值
    sysEntityExtDto: {
      type: Array,
      default: () => ({}),
    },
  },
  data() {
    return {
      // *************主表状态
      labelStyle: {
        "text-align": "center",
        "font-weight": "600",
        "min-width": "110px",
        "word-break": "keep-all",
      },
      sysEntityExtDtoKey: null,
      // --------------------文件上传
      tableList: [],
      dialogType: 1,
      markIndex: 1,
      dialogTitle: "",
      dialogState: {
        show1: false,
      },
    };
  },
  created() {},
  methods: {
    // 字典处理
    customSelectDataShow(val, list) {
      if (list) {
        let single = list.filter((item) => {
          return item.value == val;
        });
        return single.length > 0 ? single[0].label : "";
      }
    },
    // 打开excel
    mainExcelOpen(value) {
      const { href } = this.$router.resolve({
        path: "/excelEditV2",
        query: {
          value: value,
        },
      });
      window.open(href);
    },
    mainExcelSuccess(row, key, item, index) {
      let fileInfoId = 0;
      try {
        fileInfoId = JSON.parse(item.fieldTypeRelinfo).fileInfoId;
      } catch (error) {
        fileInfoId = 0;
      }
      let json = {
        fileInfoWithWpsDto: {
          fileInfoId: fileInfoId,
          model: "文件",
        },
      };
      fileInfo_getFileId(json).then((res) => {
        switch (index) {
          case 66:
            this.sysEntityExtDto[key] = res.data.data;
            break;
          default:
            break;
        }
        this.$forceUpdate();
        const { href } = this.$router.resolve({
          path: "/excelEditV2",
          query: {
            value: res.data.data,
          },
        });
        window.open(href);
      });
    },
    // 自定义自带段处理文件附件
    getFileList(list) {
      let count = 0;
      try {
        count = JSON.parse(list).length;
      } catch (error) {
        count = 0;
      }
      return count;
    },
    updateFileList(list, item, markIndex) {
      this.sysEntityExtDtoKey = item;
      this.dialogType = 2;
      this.dialogStatus = 0;
      this.dialogTitle = item.fieldName;
      this.markIndex = markIndex;
      try {
        this.tableList = JSON.parse(list);
      } catch (error) {
        this.tableList = [];
      }
      this.dialogState.show1 = true;
    },
    uploadSuccess(list, type, markIndex) {
      switch (markIndex) {
        case 66:
          this.sysEntityExtDto[
            this.sysEntityExtDtoKey.fieldTag.substring(
              this.sysEntityExtDtoKey.fieldTag.indexOf("-") + 1,
              this.sysEntityExtDtoKey.fieldTag.length
            )
          ] = JSON.stringify(list);
          break;
        default:
          break;
      }
      this.tableList = list;
      this.$forceUpdate();
    },
    uploadDelete(list, type, markIndex) {
      switch (markIndex) {
        case 66:
          this.sysEntityExtDto[
            this.sysEntityExtDtoKey.fieldTag.substring(
              this.sysEntityExtDtoKey.fieldTag.indexOf("-") + 1,
              this.sysEntityExtDtoKey.fieldTag.length
            )
          ] = JSON.stringify(list);
          break;
        default:
          break;
      }
      this.tableList = list;
      this.$forceUpdate();
    },
    dialogClose() {
      this.dialogState.show1 = false;
    },
  },
};
</script>
<style scoped></style>
